var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61426 14.3125C7.32086 14.3125 7.08301 14.0747 7.08301 13.7812L7.08301 3.86458C7.08301 3.57118 7.32086 3.33333 7.61426 3.33333C7.90766 3.33333 8.14551 3.57118 8.14551 3.86458L8.14551 13.7813C8.14551 14.0747 7.90766 14.3125 7.61426 14.3125Z",
    fill: "#3E3E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07324 11.6562C3.77984 11.6562 3.54199 11.4184 3.54199 11.125L3.54199 7.05208C3.54199 6.75868 3.77984 6.52083 4.07324 6.52083C4.36664 6.52083 4.60449 6.75868 4.60449 7.05208L4.60449 11.125C4.60449 11.4184 4.36664 11.6562 4.07324 11.6562Z",
    fill: "#3E3E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9268 11.6562C12.6334 11.6562 12.3955 11.4184 12.3955 11.125L12.3955 7.05208C12.3955 6.75868 12.6334 6.52083 12.9268 6.52083C13.2202 6.52083 13.458 6.75868 13.458 7.05208L13.458 11.125C13.458 11.4184 13.2202 11.6562 12.9268 11.6562Z",
    fill: "#3E3E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38574 11.6562C9.09234 11.6562 8.85449 11.4184 8.85449 11.125L8.85449 7.05208C8.85449 6.75868 9.09234 6.52083 9.38574 6.52083C9.67914 6.52083 9.91699 6.75868 9.91699 7.05208L9.91699 11.125C9.91699 11.4184 9.67914 11.6562 9.38574 11.6562Z",
    fill: "#3E3E4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1562 13.073C10.8628 13.073 10.625 12.8351 10.625 12.5417L10.625 5.28133C10.625 4.98793 10.8628 4.75008 11.1562 4.75008C11.4497 4.75008 11.6875 4.98793 11.6875 5.28133L11.6875 12.5417C11.6875 12.8351 11.4497 13.073 11.1562 13.073Z",
    fill: "#3E3E4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84375 13.073C5.55035 13.073 5.3125 12.8351 5.3125 12.5417L5.3125 5.28133C5.3125 4.98793 5.55035 4.75008 5.84375 4.75008C6.13715 4.75008 6.375 4.98793 6.375 5.28133L6.375 12.5417C6.375 12.8351 6.13715 13.073 5.84375 13.073Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon3);
export default __webpack_public_path__ + "static/media/file-icon-3.278f43eba2b3121ce2d280b6e4969ce4.svg";
export { ForwardRef as ReactComponent };